import InsightsBoard from "./insights-board.js";

export default InsightsBoard;
